import request from '@/utils/request'

/**
 * 获取联系我们页面所有公开数据
 */
export function getPublicContactAll() {
  return request({
    url: '/cms/contact/public/all',
    method: 'get'
  })
}

/**
 * 提交询价单
 */
export function submitPublicInquiry(data) {
  return request({
    url: '/cms/contact/public/inquiry',
    method: 'post',
    data: data
  })
}
